export default __webpack_public_path__ + "static/hello fm-ddd4cc9274e67153d055790bbe3a8bc1.jpg";